export const SHOPKEEPER_STATUS = {
  PENDING: 'PENDING',
  ISSUED: 'ISSUED',
  REJECTED: 'REJECTED',
} as const;

export type ShopkeeperStatus =
  typeof SHOPKEEPER_STATUS[keyof typeof SHOPKEEPER_STATUS];
